import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable, coalesce } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export interface Props {
    value: models.GuiaEntregaZESelect;
    onSeleccionar: (x: boolean | null) => void;
    onMotivoChange: (x: string) => void;
    nuevo: boolean;
}

const OptionButton = (props: { selected: boolean, onClick: () => void, children: string, disabled: boolean }) =>
    <kea.Button onClick={props.onClick} style={props.selected ? "info" : "default"} >
        {props.children}
    </kea.Button>;
const Entregada = (props: { selected: boolean, onClick: () => void, disabled: boolean }) => <OptionButton {...props} children="Entregada" />;
const Rechazada = (props: { selected: boolean, onClick: () => void, disabled: boolean }) => <OptionButton {...props} children="Rechazada" />;

export class GuiaItem extends React.PureComponent<Props> {
    render() {
        const x = this.props.value;
        const nuevo = this.props.nuevo;
        return (
            <kea.Panel
                title={
                    <span style={{ fontFamily: "monospace" }} >
                        {x.Guia.Folio}
                    </span>
                }
                style={x.Seleccionada == false ? "danger" : x.Seleccionada == true ? "success" : "default"}  >
                <div className="btn-group">
                    <Rechazada selected={x.Seleccionada == false} onClick={() => this.props.onSeleccionar(false)} disabled={!nuevo} />
                    <Entregada selected={x.Seleccionada == true} onClick={() => this.props.onSeleccionar(true)} disabled={!nuevo} />
                </div>

                {
                    <kea.Text value={x.MotivoRechazo} placeholder="Motivo de rechazo" onChange={this.props.onMotivoChange} readonly={nuevo ? x.Seleccionada != false : true} />
                }
                <br />

                <label>Importe a pagar:</label>{" "}{
                    kea.formatCurrency(
                        (x.Guia.FletePorCobrar) ?
                            x.Guia.Importes.Total : 0)}
                <br />

                <label>Paquetes:</label>
                {
                    x.Guia.DescripcionPaquetesTexto ?
                        <ul>
                            {x.Guia.DescripcionPaquetesTexto.split(",").map((x, i) => <li key={i} >{x}</li>)}
                        </ul> :
                        <i>Ninguno</i>
                }
                <br />
                <label>Sobres:</label>{x.Guia.CantidadSobres}
                <br />
                <label>Tipo acuse:</label>{" "}{coalesce(nullsafe(x.Guia.ServiciosAdicionales.TipoAcuse, x => models.TipoAcuse[x]), "(ninguno)")}{" "}{x.Guia.ServiciosAdicionales.TipoAcuse == models.TipoAcuse.Externo ? ("(" + x.Guia.ServiciosAdicionales.NombreRequerimientoAcuse + ")") : ""}
            </kea.Panel>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entrega/list/item.tsx